import { Color } from "./interface"

export const colors: Color[] = [
  {
    id: 'coyote-tan',
    name: 'コヨーテタン',
    colorCode: '#E2CD99'
  },
  {
    id: 'olive-drab',
    name: 'オリーブドラブ',
    colorCode: '#5A5D47'
  },
  {
    id: 'red',
    name: 'レッド',
    colorCode: '#C30D23'
  },
  {
    id: 'jet-black',
    name: 'ジェットブラック',
    colorCode: '#060202'
  },
  {
    id: 'charcoal',
    name: 'チャコール',
    colorCode: '#394046'
  },
  {
    id: 'snow-white',
    name: 'スノーホワイト',
    colorCode: '#EFEEF2'
  }
]